import { Component } from 'react';
import PropTypes from 'prop-types';
import BranchService from '../BranchService';

class Branch extends Component {
  static propTypes = {
    branchKey: PropTypes.string,
  }
  static defaultProps = {
    branchKey: null,
  }

  componentDidMount() {
    this.branch = new BranchService(this.props.branchKey);
  }

  componentDidUpdate(prevProps) {
    const keyLoaded = this.props.branchKey !== undefined;
    const keyChanged = this.props.branchKey !== prevProps.branchKey;

    if (keyChanged && keyLoaded) {
      this.branch.destroy();
      this.branch = new BranchService(this.props.branchKey);
    }
  }

  render() { return null; }
}

export default Branch;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/branch/components/Branch.js